import styled from 'styled-components';

// Helpers
import { card } from '~/App/helpers/mixins';

export const AccountColumn = styled.div`
  ${card}
  width: 100%;
`;
